import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Spinner } from 'portal/lib/primitives'
import { useMountEffect, useUserProjectRole } from 'portal/lib/hooks'

import { Details } from 'portal/components/RecordsModules'
import { PageContainer } from 'portal/pages/PageContainer'
import {
  useRecordDetailData,
  useRecordDetailsMixpanel
} from 'portal/components/RecordDetails'
import { InfractionsContext } from 'portal/store/infractions/InfractionsContext'
import { projectUsersLoad } from 'portal/store/projectUsers/actions'

import { Sidebar } from 'portal/components/Sidebar'

export function DeliveryDetails() {
  const { loading, error, item: record, infractions } = useRecordDetailData()

  const { trackDetailsOpened } = useRecordDetailsMixpanel()
  useMountEffect(trackDetailsOpened)

  const { accountId, projectId } = useParams()
  const dispatch = useDispatch()
  const { isProjectUser, roleLoaded } = useUserProjectRole(accountId, projectId)

  // Load Project Users in to Redux state
  useEffect(() => {
    if (roleLoaded && isProjectUser) {
      dispatch(projectUsersLoad(accountId, projectId, false))
    }
  }, [accountId, dispatch, isProjectUser, projectId, roleLoaded])

  return (
    <PageContainer>
      <Sidebar />

      {loading && <Spinner />}
      {error && <div>Qflowing...</div>}

      {record && infractions && (
        <InfractionsContext infractionsByFieldName={infractions}>
          <Details.Delivery record={record} />
        </InfractionsContext>
      )}
    </PageContainer>
  )
}
